import { Flex, Link, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { usePathname, useRouter } from 'next/navigation';
import { useCallback } from 'react';

import CreateGiftCardPage from '@features/giftCards/CreateGiftCardPage';
import GiftCardIntroCard from '@features/giftCards/GiftCardIntroCard';
import { useSidebarNavigationEntities } from 'hooks/useNavigationEntities';

const isCreateGiftCardPath = (giftCardsPath: string, currentPath: string) => {
  return `${giftCardsPath}/create` === currentPath;
};

const GiftCardsPage = () => {
  const { selectedNavigationEntity } = useSidebarNavigationEntities();
  const pathname = usePathname();
  const giftCardsPagePath = selectedNavigationEntity?.absolutePath ?? '';
  const router = useRouter();

  const handleBack = useCallback(() => {
    router.replace(giftCardsPagePath);
  }, [router, giftCardsPagePath]);

  const onClickCreateGiftCard = useCallback(() => {
    router.push(`${giftCardsPagePath}/create`);
  }, [router, giftCardsPagePath]);

  if (isCreateGiftCardPath(giftCardsPagePath, pathname)) {
    return <CreateGiftCardPage goBack={handleBack} />;
  }

  return (
    <Flex flexDir="column" gap={4} pt={8} px={4} h="full">
      <GiftCardIntroCard onClickCreateGiftCard={onClickCreateGiftCard} />
      <Flex justifyContent="center">
        <Text fontSize="xs">
          Learn more about <Link variant="underline">gift cards</Link>
        </Text>
      </Flex>
    </Flex>
  );
};

export default observer(GiftCardsPage);
